import formatDate from 'date-format';

export function normalizeFacebookProfileData(profileData) {
  const getBirthday = (fbBirthday) => {
    if (!fbBirthday) return '';
    if (!/\d{1,2}\/\d{1,2}\/\d{4}/.test(profileData.birthday)) return '';

    const birthdayAsDate = new Date(profileData.birthday);
    if (Number.isNaN(birthdayAsDate)) return '';

    return formatDate('yyyy/MM/dd', birthdayAsDate);
  };

  const getGender = (fbGender) => {
    if (fbGender === 'male') return 'male';
    if (fbGender === 'female') return 'female';
    return undefined;
  };

  return {
    name: profileData.name || '',
    birthday: getBirthday(profileData.birthday),
    email: profileData.email || '',
    gender: getGender(profileData.gender),
    id: profileData.id || '',
    accessToken: profileData.accessToken || ''
  };
}
